import React from "react";
import {
    Select,
    MenuItem,
    FormControl,
    Box,
    Typography,
    useTheme,
} from "@mui/material";
import { TiArrowUnsorted } from "react-icons/ti";
import { AiOutlineCheck } from "react-icons/ai";
import { IGenericOptions } from "types/Generics";
import { useAppDispatch } from "redux/hooks";
import { setInventoryHealthSelectedPeriod } from "redux/Filters/reducer";

interface FilterDropDownPeriodSelectorProps {
    periodOptions: IGenericOptions[]
    selectedPeriod: IGenericOptions
}
const FilterDropDownPeriodSelector: React.FC<FilterDropDownPeriodSelectorProps> = ({
    periodOptions, selectedPeriod
}) => {
    const dispatch = useAppDispatch()
    const theme = useTheme()
    if (!periodOptions || !selectedPeriod) return
    return (
        <FormControl fullWidth>
            <Select
                labelId="period-select-label"
                id="company-select"
                size="small"
                variant="outlined"
                inputProps={{
                    sx: {
                        paddingTop: '0.3rem',
                        paddingBottom: '0.1rem',
                        backgroundColor: theme.palette.background.default
                    }
                }}
                value={selectedPeriod.id}
                onChange={(e) => {
                    const selectedOption = periodOptions.find((filter) => filter.id === e.target.value);
                    if (selectedOption)
                        dispatch(setInventoryHealthSelectedPeriod({ period: selectedOption }));
                }}
                IconComponent={TiArrowUnsorted}
            >
                {periodOptions.map((period, index) => (
                    <MenuItem key={period.id} value={period.id as number}>
                        <Box display="flex" alignItems="center" gap={'0.3rem'}>
                            <Typography variant="caption">{period.name}</Typography>
                            {selectedPeriod.id === period.id && (
                                <AiOutlineCheck fontSize="small" />
                            )}
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default FilterDropDownPeriodSelector;
